import 'ssd-form';

export default class {

    constructor() {

        this.form = $('form[data-ajax-form]');

        if (this.form.length > 0) {
            this.setForm();
        }

        this.goTo();
    }

    setForm() {
        this.form.ssdForm();
    }

    goTo() {
        $('select[data-select-go-to]').on('change', function() {
            window.location.href = $(this).val();
        });
    }
}